import * as THREE from 'three';

// Loads the hourglass tools/build-hourglass.mjs prepared - the photo with the
// hourglass, the plate without it, the hourglass's mask, the glass's
// reflections and the glass's inner profile - once, at startup, for
// visualizers/hourglass.js. Same preload/get shape as fairground-assets.js,
// and the same rule: the preload is a WIRING POINT every entry point must call
// (main, main-radio, main-embedded, play-boot, player-boot, landing-boot,
// demo-boot, the capture harness). Resolves to null when any file is missing:
// the entry points then withdraw Hourglass - without both photos it is
// unavailable.
const MANIFEST_URL = 'textures/hourglass.json';

let _assets = null;
let _promise = null;

function loadTexture(url, srgb, nearest) {
  return new Promise(function (resolve, reject) {
    new THREE.TextureLoader().load(url, function (t) {
      t.colorSpace = srgb ? THREE.SRGBColorSpace : THREE.NoColorSpace;
      t.generateMipmaps = false;
      t.minFilter = t.magFilter = nearest ? THREE.NearestFilter : THREE.LinearFilter;
      t.wrapS = t.wrapT = THREE.ClampToEdgeWrapping;
      t.needsUpdate = true;
      resolve(t);
    }, undefined, function () { reject(new Error(url + ' failed to load')); });
  });
}

export function preloadHourglass() {
  if (_promise) return _promise;
  _promise = fetch(MANIFEST_URL)
    .then(function (r) {
      if (!r.ok) throw new Error('hourglass.json HTTP ' + r.status);
      return r.json();
    })
    .then(function (m) {
      if (!m.webp || !m.plate || !m.png || !m.refl || !m.profile || !m.tables || !m.inner) throw new Error('hourglass.json incomplete (run tools/build-hourglass.mjs)');
      return Promise.all([
        loadTexture('textures/' + m.webp, true, false),
        loadTexture('textures/' + m.plate, true, false),
        loadTexture('textures/' + m.png, false, false),
        loadTexture('textures/' + m.refl, true, false),
        loadTexture('textures/' + m.profile, false, true)
      ]).then(function (t) {
        _assets = { manifest: m, photo: t[0], plate: t[1], mask: t[2], refl: t[3], profile: t[4] };
        return _assets;
      });
    })
    .catch(function (err) {
      console.error('[party-mode] hourglass assets unavailable, Hourglass will not be offered', err);
      _assets = null;
      return null;
    });
  return _promise;
}

export function getHourglass() {
  return _assets;
}
